export default "__VITE_ASSET__fa173489__"